import { render, staticRenderFns } from "./StepComponent.vue?vue&type=template&id=31252e07&scoped=true"
import script from "./StepComponent.vue?vue&type=script&lang=js"
export * from "./StepComponent.vue?vue&type=script&lang=js"
import style0 from "./StepComponent.vue?vue&type=style&index=0&id=31252e07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31252e07",
  null
  
)

export default component.exports